import { render, staticRenderFns } from "./LabDisplacementReactions.vue?vue&type=template&id=22e6c392&"
import script from "./LabDisplacementReactions.vue?vue&type=script&lang=ts&"
export * from "./LabDisplacementReactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports